import intl from "react-intl-universal";
import { TbHeadset } from "react-icons/tb";

import {
  CARD_BORDER_RADIUS,
  CARD_INSET_HORIZONTAL,
  CARD_INSET_VERTICAL,
  CARD_PREVIEW_HEIGHT,
  CARD_PREVIEW_WIDTH,
  DEFAULT_CARD_BACK_PHONE_METROPOLITAN,
  DEFAULT_CARD_BACK_PHONE_OTHER,
  DEFAULT_CARD_BACK_WEBSITE,
  DEFAULT_CARD_NUMBER_PREVIEW,
  DEFAULT_CARDHOLDER_PREVIEW_NAME,
  DEFAULT_CVC_PREVIEW,
  DEFAULT_EXPIRY_PREVIEW,
} from "../cardProgramDesignConstants";

const BACKGROUND_COLOR = "#000000";
const TEXT_COLOR = "#ffffff";

export const CardDesignPreviewBack = ({
  website = DEFAULT_CARD_BACK_WEBSITE,
  phoneMetropolitan = DEFAULT_CARD_BACK_PHONE_METROPOLITAN,
  phoneOther = DEFAULT_CARD_BACK_PHONE_OTHER,
  cardNumberPreview = DEFAULT_CARD_NUMBER_PREVIEW,
  expiryPreview = DEFAULT_EXPIRY_PREVIEW,
  cvcPreview = DEFAULT_CVC_PREVIEW,
  cardholderName = DEFAULT_CARDHOLDER_PREVIEW_NAME,
  backArt = null,
}) => (
  <div
      className="relative overflow-hidden"
      style={{
        width: CARD_PREVIEW_WIDTH,
        height: CARD_PREVIEW_HEIGHT,
        borderRadius: CARD_BORDER_RADIUS,
        backgroundColor: BACKGROUND_COLOR,
        color: TEXT_COLOR,
        fontFamily: "system-ui, -apple-system, sans-serif",
      }}
    >
      {backArt ? (
        <img
          src={backArt}
          alt=""
          className="absolute inset-0 h-full w-full object-cover"
          aria-hidden
        />
      ) : null}
      <div
        className="absolute left-0 right-0"
        style={{
          top: 24,
          height: 49,
          backgroundColor: "#1a1a1a",
          zIndex: 1,
        }}
        aria-hidden="true"
      />

      <div
        className="absolute"
        style={{
          left: CARD_INSET_HORIZONTAL,
          top: 86,
          right: CARD_INSET_HORIZONTAL,
          zIndex: 1,
        }}
      >
        <p
          className="font-mono tracking-[0.18em]"
          style={{ fontSize: 14, lineHeight: "18px", letterSpacing: "0.12em" }}
        >
          {cardNumberPreview}
        </p>

        <div className="mt-2 flex items-end gap-5">
          <div>
            <span
              className="block uppercase"
              style={{ fontSize: 7, lineHeight: "9px", opacity: 0.75 }}
            >
              {intl.get("baas.cartoes.design.back.expLabel")}
            </span>
            <span className="font-mono" style={{ fontSize: 12, lineHeight: "16px" }}>
              {expiryPreview}
            </span>
          </div>
          <div>
            <span
              className="block uppercase"
              style={{ fontSize: 7, lineHeight: "9px", opacity: 0.75 }}
            >
              {intl.get("baas.cartoes.design.back.cvcLabel")}
            </span>
            <span className="font-mono" style={{ fontSize: 12, lineHeight: "16px" }}>
              {cvcPreview}
            </span>
          </div>
        </div>

        <p
          className="mt-3 max-w-full truncate uppercase tracking-wide"
          style={{ fontSize: 11, lineHeight: "14px" }}
        >
          {cardholderName || DEFAULT_CARDHOLDER_PREVIEW_NAME}
        </p>
      </div>

      <div
        className="absolute"
        style={{
          left: CARD_INSET_HORIZONTAL,
          bottom: CARD_INSET_VERTICAL,
          maxWidth: "62%",
          zIndex: 1,
        }}
      >
        <div className="mb-1.5 flex items-center gap-1.5">
          <TbHeadset size={14} aria-hidden="true" />
          <span style={{ fontSize: 11, lineHeight: "14px", fontWeight: 500 }}>
            {intl.get("baas.cartoes.design.back.helpTitle")}
          </span>
        </div>

        <p
          className="uppercase"
          style={{ fontSize: 8, lineHeight: "12px", letterSpacing: "0.02em" }}
        >
          {intl.get("baas.cartoes.design.back.phoneMetropolitanLabel")}: {phoneMetropolitan}
        </p>

        <p
          className="uppercase"
          style={{ fontSize: 8, lineHeight: "12px", letterSpacing: "0.02em" }}
        >
          {intl.get("baas.cartoes.design.back.phoneOtherLabel")}: {phoneOther}
        </p>

        <p className="mt-2" style={{ fontSize: 10, lineHeight: "14px" }}>
          {website}
        </p>
    </div>
  </div>
);
